module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"train-car":"Вагон поезда"},"en":{"train-car":"Train car"}}')
  delete Component.options._Ctor
}
